var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g, _path76, _g2, _path77, _g3, _path78, _g4, _path79, _g5, _path80, _g6, _path81, _g7, _path82, _g8, _path83, _g9, _path84, _g10, _path85, _g11, _path86, _g12, _path87, _g13, _path88, _g14, _path89, _g15, _path90, _g16, _path91, _g17, _path92, _g18, _path93, _g19, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g20, _path114, _g21, _path115, _g22, _path116, _g23, _path117, _g24, _path118, _g25, _path119, _g26, _path120, _g27, _path121, _g28, _path122, _g29, _path123, _g30, _path124, _g31, _path125, _g32, _path126, _g33, _path127, _g34, _path128, _g35, _path129, _g36, _path130, _g37, _path131, _g38, _path132, _g39, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.027 9.76991L18.6954 9.38478V7.60696L18.027 7.9921V9.76991Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6566 9.33146V7.81134L18.2115 8.06778V9.5879L18.6566 9.33146Z",
    fill: "#42413D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6954 7.60696L18.6571 7.81162L18.2119 8.06806L18.027 7.9921L18.6954 7.60696Z",
    fill: "#949491"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2119 9.58817L18.027 9.7699L18.6954 9.38477L18.6571 9.33173L18.2119 9.58817Z",
    fill: "#424242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7274 9.81258C18.7274 10.0273 18.5632 10.3016 18.3611 10.4256C18.1586 10.5496 17.9944 10.4761 17.9944 10.2614C17.9944 10.0467 18.1586 9.7724 18.3611 9.64842C18.5632 9.52444 18.7274 9.5982 18.7274 9.81258Z",
    fill: "#6A6869"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5553 10.2464C18.4988 10.3186 18.4325 10.3817 18.361 10.4256C18.3264 10.4466 18.2938 10.4601 18.2621 10.4702C18.3066 10.3948 18.3685 10.3273 18.4369 10.2853C18.4799 10.2589 18.5201 10.2473 18.5553 10.2464Z",
    fill: "#424242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1915 9.79773C18.2424 9.7384 18.2995 9.68567 18.3607 9.64832C18.4816 9.57425 18.5877 9.57205 18.6545 9.62697C18.6551 9.63545 18.6567 9.64361 18.6567 9.6524C18.6567 9.81844 18.5453 9.9531 18.4078 9.9531C18.3146 9.95278 18.2339 9.89001 18.1915 9.79773Z",
    fill: "#EBEAE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6825 9.90713C18.6825 10.0509 18.5726 10.2348 18.437 10.3177C18.3014 10.4006 18.1915 10.3513 18.1915 10.2078C18.1915 10.0641 18.3014 9.88014 18.437 9.79727C18.5726 9.71409 18.6825 9.76338 18.6825 9.90713Z",
    fill: "#9A998E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3936 8.93859L18.5405 8.85416V9.12253L18.3936 9.20696L18.3606 9.18813V8.91976L18.3936 8.93859Z",
    fill: "#7B7B6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5408 9.04931V8.78094L18.3939 8.86538V9.13375L18.5408 9.04931Z",
    fill: "#6A6869"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5405 8.78078L18.5075 8.76163L18.3606 8.84607L18.3936 8.86521L18.5405 8.78078Z",
    fill: "#EBEAE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3606 9.11487V8.84619L18.3936 8.86533V9.13371L18.3606 9.11487Z",
    fill: "#424242"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3936 10.0553L18.5405 9.97055V10.1526L18.3936 10.237L18.3606 10.2179V10.0362L18.3936 10.0553Z",
    fill: "#7B7B6D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5408 10.079V9.89697L18.3939 9.98172V10.1635L18.5408 10.079Z",
    fill: "#6A6869"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5405 9.89716L18.5075 9.87833L18.3606 9.96276L18.3936 9.98191L18.5405 9.89716Z",
    fill: "#EBEAE5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3606 10.1443V9.96255L18.3936 9.9817V10.1634L18.3606 10.1443Z",
    fill: "#424242"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8546 11.1094V10.9946L18.4444 10.4374V7.31118L18.2696 7.18123L18.2963 7.09711L18.5283 7.26911V10.4735L17.8546 11.1094Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599678 4.25696L13.0332 11.4385V16.9026L0.599678 9.72098V4.25696Z",
    fill: "#C5CAD8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599678 7.42114L13.036 14.6011L13.0332 14.5029L12.9271 14.1774L0.599678 7.06018V7.42114Z",
    fill: "#FFB700"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0436 15.3589L11.3832 15.4207L10.9456 16.1568L10.9993 16.2481L12.3259 15.4471L12.0436 15.3589Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94953 13.0559L10.4198 13.3321V12.9827L9.94953 12.7065V13.0559Z",
    fill: "#727071"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9722 14.8031L9.72782 14.0579V9.61902L11.7008 10.7575L11.708 10.7615L12.4972 13.3269L12.4981 13.3303L12.4633 15.5909L10.9722 14.8031ZM11.6719 10.7904L9.77083 9.69372V14.0334L10.9932 14.7657L12.4212 15.5196L12.4548 13.3363L11.6719 10.7904Z",
    fill: "#AEAEAE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3273 10.87L13.0337 14.5028L12.7665 13.6836L19.0605 10.0504L19.3273 10.87Z",
    fill: "#D1EBEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0605 10.0504L20.3746 12.4689L15.7685 15.1281L12.7665 13.6836L19.0605 10.0504Z",
    fill: "#E3EAF5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9163 10.7944L18.2097 7.16119L19.0604 10.0505L12.7664 13.6836L11.9163 10.7944Z",
    fill: "#BDC3D6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2028 7.87157L18.6057 8.91428L18.1932 7.53258C18.1621 7.43119 18.046 7.38412 17.9546 7.43779L17.2028 7.87157Z",
    fill: "#829AA9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5478 9.59026L18.5277 9.51682V9.58932C18.5346 9.58901 18.5412 9.58901 18.5478 9.59026Z",
    fill: "#C0FFFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.027 7.99219V9.76969L18.4442 9.52894V9.60804C18.443 9.60804 18.442 9.6093 18.4408 9.6093C18.4364 9.61149 18.4307 9.61369 18.4263 9.61495C18.405 9.62374 18.384 9.63503 18.3604 9.64853C18.3315 9.66736 18.3023 9.68965 18.2747 9.71319C18.2725 9.71539 18.2703 9.71758 18.2681 9.72104C18.227 9.75776 18.189 9.80013 18.1545 9.84596L18.4031 9.98972C18.5145 10.0544 18.6486 9.9508 18.6141 9.82587L18.5481 9.59046C18.5415 9.58952 18.5346 9.58952 18.528 9.58952V9.51702L18.2973 8.68523L18.0942 7.95483L18.027 7.99219Z",
    fill: "#65818A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0266 9.7698V8.48415V7.9923L18.0935 7.95432L18.0455 7.78357L17.5046 8.09588L16.4238 8.72019C16.4885 8.83946 16.5855 8.94084 16.7069 9.01115L18.1535 9.84514C18.188 9.79931 18.226 9.75693 18.2671 9.72021C18.2693 9.71676 18.2715 9.71456 18.2737 9.71236C18.3016 9.68882 18.3305 9.66653 18.3594 9.6477C18.3829 9.6342 18.404 9.62322 18.4253 9.61412C18.4297 9.61318 18.4354 9.61066 18.4398 9.60847C18.441 9.60847 18.442 9.60721 18.4432 9.60721V9.52811L18.0266 9.7698Z",
    fill: "url(#paint0_linear_794_29231)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7986 9.56327L18.6056 8.91417L18.2967 8.68441L18.6134 9.82505C18.6479 9.94997 18.5142 10.0536 18.4025 9.9889L16.7073 9.01085C16.5858 8.94054 16.4888 8.83915 16.4242 8.71988L17.505 8.09557L17.2027 7.87146L15.5647 8.81687L15.5644 8.81655L14.0042 9.7177V9.71802L12.3659 10.6637L12.3593 10.6672C12.171 10.7752 12.0828 10.9996 12.144 11.208L12.6246 12.8182C12.6334 12.8471 12.6434 12.875 12.6569 12.9017C12.7975 13.1996 13.1689 13.322 13.4633 13.1525L14.729 12.4221L14.1869 12.0184L13.7459 11.6901L14.3197 11.3593L14.7925 11.6694L15.8252 11.0727L16.3674 11.4761L17.9275 10.5749L17.3854 10.1716L17.4636 10.127C17.6933 9.99423 17.9711 9.9798 18.2141 10.0846L18.5343 10.2252C18.765 10.0919 18.8743 9.81752 18.7986 9.56327Z",
    fill: "url(#paint1_linear_794_29231)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.126953 9.44675L11.2527 15.8731V16.349V16.5134L0.126953 10.0871V9.44675Z",
    fill: "#FFB700"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2247 18.5588L11.5356 16.432V15.7841L15.2247 17.911V18.5588Z",
    fill: "#1C1C1A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6118 15.6338L9.58467 15.039V15.4216L10.6118 16.0167V15.6338Z",
    fill: "#555454"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8251 15.2534L9.53207 14.4985V14.8814L9.64132 14.9411L10.8251 15.6363V15.2534Z",
    fill: "#767576"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6115 15.6338L9.58467 15.039V15.4219L9.75481 15.4144C9.9711 15.405 10.1792 15.4969 10.3177 15.6636L10.6115 16.0167V15.6338Z",
    fill: "#181818"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8251 15.2534L9.53207 14.4985V14.8811H9.72796C10.0014 14.9182 10.454 15.1759 10.6217 15.3676L10.8251 15.636V15.2534Z",
    fill: "#555454"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1581 18.0385L21.0192 14.6552V14.4963L15.1581 17.8797V18.0385Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2142 10.0854C17.9713 9.98053 17.6934 9.99496 17.4637 10.1277L17.3855 10.1723L15.8253 11.0735L14.7926 11.6701L14.3198 11.36L13.7453 11.6912L12.678 12.3067L12.6802 12.8732L12.6567 12.9021C12.7973 13.2 13.1687 13.3224 13.4631 13.1529L14.7288 12.4225L16.3672 11.4768L17.9273 10.5756L18.5341 10.2254L18.2142 10.0854Z",
    fill: "#6F94A3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1433 11.6055L15.7484 11.8333L14.8911 9.20554L15.286 8.97766L16.1433 11.6055Z",
    fill: "#BDC3D6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9355 10.8054C11.9276 10.7595 11.922 10.714 11.922 10.6647C11.922 10.5699 11.9377 10.4795 11.9656 10.4014L0.793399 3.94739L0.600342 4.25625L11.9355 10.8054Z",
    fill: "#FFB700"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9656 10.4017C11.9377 10.4799 11.922 10.5699 11.922 10.665C11.922 10.714 11.9276 10.7598 11.9355 10.8057L12.0158 10.8524C12.1263 10.9158 12.25 10.9485 12.374 10.9472C12.4252 10.9472 12.4754 10.9416 12.5256 10.9306C12.5768 10.9205 12.627 10.9039 12.6751 10.8804C12.6939 10.8725 12.7131 10.8625 12.7319 10.8524L18.3271 7.62198C18.4332 7.56077 18.4643 7.43805 18.4241 7.33886C18.4062 7.29649 18.2411 7.05449 18.1934 7.02435C18.1934 7.02341 18.1921 7.02216 18.1912 7.02216L6.89403 0.624023L0.793427 3.94833L11.9656 10.4017Z",
    fill: "#F7900B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9223 10.665C11.9223 10.714 11.928 10.7598 11.9358 10.8057L12.0162 10.8524C12.1267 10.9158 12.2503 10.9485 12.3743 10.9472C12.4246 10.9472 12.4757 10.9416 12.526 10.9306C12.5762 10.9196 12.6274 10.9026 12.6754 10.8804C12.6933 10.8135 12.7043 10.741 12.7043 10.665C12.7043 10.6082 12.6986 10.5536 12.6876 10.5021C12.6408 10.2645 12.4902 10.0919 12.3128 10.0919C12.1621 10.0919 12.0306 10.2178 11.9659 10.402C11.9377 10.4798 11.9223 10.5702 11.9223 10.665Z",
    fill: "#DD9100"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0.793427 3.94762L11.9656 10.4016L12.0749 10.465C12.2632 10.5733 12.4899 10.5865 12.687 10.5018C12.7127 10.4917 12.7382 10.4795 12.763 10.465L18.1419 7.3595C18.2668 7.28699 18.2847 7.12189 18.1931 7.02396C18.1931 7.02302 18.1918 7.02176 18.1909 7.02176C18.1774 7.00607 18.1607 6.99383 18.1419 6.98284L6.84255 0.455078L0.793427 3.94762Z",
    fill: "#FFE057"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10046 2.0385C4.1623 2.00303 4.23827 2.00303 4.29979 2.0385L15.5263 8.52389C15.6594 8.6008 15.6594 8.79258 15.5263 8.86948C15.4645 8.90526 15.3885 8.90526 15.3267 8.86948L4.10015 2.38408C3.96736 2.30718 3.96736 2.11509 4.10046 2.0385Z",
    fill: "#F7900B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 7.73196C17.4348 7.76775 17.3589 7.76775 17.297 7.73196L6.07053 1.24657C5.93743 1.16967 5.93743 0.977892 6.07053 0.900991C6.13237 0.865523 6.20834 0.865523 6.26986 0.900991L17.4964 7.38638C17.6295 7.46328 17.6295 7.65538 17.4967 7.73196Z",
    fill: "#F7900B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08557 1.4698C5.14741 1.43402 5.22337 1.43402 5.28521 1.4698L16.5117 7.95519C16.6448 8.03209 16.6448 8.22387 16.5117 8.30077C16.4499 8.33624 16.3739 8.33624 16.3121 8.30077L5.08557 1.81538C4.95278 1.73848 4.95278 1.5467 5.08557 1.4698Z",
    fill: "#F7900B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13008 3.17568C2.19192 3.14021 2.26788 3.14021 2.32972 3.17568L13.5562 9.66138C13.6893 9.73797 13.6893 9.93006 13.5562 10.007C13.4944 10.0424 13.4184 10.0424 13.3566 10.007L2.13008 3.52126C1.99729 3.44467 1.99729 3.25258 2.13008 3.17568Z",
    fill: "#F7900B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11503 2.60741C3.17687 2.57194 3.25284 2.57194 3.31468 2.60741L14.5412 9.09311C14.6743 9.17002 14.6743 9.3618 14.5412 9.4387C14.4793 9.47417 14.4034 9.47417 14.3415 9.4387L3.11503 2.95331C2.98193 2.87609 2.98193 2.684 3.11503 2.60741Z",
    fill: "#F7900B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10042 2.15007C4.16226 2.11428 4.23823 2.11428 4.29975 2.15007L15.5263 8.63546C15.6594 8.71236 15.6594 8.90414 15.5263 8.98104C15.4644 9.01682 15.3885 9.01682 15.3266 8.98104L4.10042 2.49565C3.96732 2.41875 3.96732 2.22697 4.10042 2.15007Z",
    fill: "#FFB700"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 7.84389C17.4348 7.87967 17.3589 7.87967 17.297 7.84389L6.07053 1.3585C5.93743 1.2816 5.93743 1.08982 6.07053 1.01292C6.13237 0.977138 6.20834 0.977138 6.26986 1.01292L17.4964 7.49831C17.6295 7.5749 17.6295 7.76699 17.4967 7.84389Z",
    fill: "#FFB700"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08557 1.58149C5.14741 1.54571 5.22337 1.54571 5.28521 1.58149L16.5117 8.0672C16.6448 8.1441 16.6448 8.33588 16.5117 8.41278C16.4499 8.44856 16.3739 8.44856 16.3121 8.41278L5.08557 1.92739C4.95278 1.85049 4.95278 1.65839 5.08557 1.58149Z",
    fill: "#FFB700"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13008 3.28761C2.19192 3.25183 2.26788 3.25183 2.32972 3.28761L13.5562 9.773C13.6893 9.8499 13.6893 10.0417 13.5562 10.1186C13.4944 10.1544 13.4184 10.1544 13.3566 10.1186L2.13008 3.63319C1.99729 3.55629 1.99729 3.3642 2.13008 3.28761Z",
    fill: "#FFB700"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11503 2.71877C3.17687 2.6833 3.25284 2.6833 3.31468 2.71877L14.5412 9.20416C14.6743 9.28106 14.6743 9.47284 14.5412 9.54974C14.4793 9.58521 14.4034 9.58521 14.3415 9.54974L3.11503 3.06435C2.98193 2.98745 2.98193 2.79567 3.11503 2.71877Z",
    fill: "#FFB700"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2088 13.2413L11.602 11.0589C11.586 11.0012 11.5587 10.9475 11.5226 10.901C11.4865 10.8546 11.4413 10.8147 11.3895 10.7849L10.201 10.0987C10.1857 10.09 10.1696 10.0834 10.1536 10.0793C10.0573 10.0545 9.95649 10.1129 9.92981 10.2086C9.92542 10.2246 9.9229 10.2416 9.9229 10.2595V11.7689C9.9229 11.8107 9.9273 11.8515 9.93421 11.8919C9.93515 11.8967 9.93609 11.901 9.93703 11.9058C9.94425 11.9447 9.9543 11.9827 9.96748 12.0197C10.0268 12.1886 10.1436 12.3348 10.3034 12.4271L11.9979 13.4052C12.1093 13.4698 12.2434 13.3659 12.2088 13.2413Z",
    fill: "url(#paint2_linear_794_29231)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8538 7.32067C14.8102 7.396 14.8896 7.52313 15.0312 7.60473C15.1727 7.68634 15.3225 7.69168 15.3661 7.61635C15.4094 7.54102 15.33 7.41389 15.1888 7.33228C15.0472 7.25067 14.8974 7.24566 14.8538 7.32067Z",
    fill: "#DB3400"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8769 7.88491C13.8336 7.96024 13.913 8.08736 14.0543 8.16897C14.1959 8.25058 14.3456 8.25592 14.3889 8.18059C14.4323 8.10525 14.3528 7.97813 14.2116 7.89653C14.0703 7.81492 13.9206 7.80989 13.8769 7.88491Z",
    fill: "#DB3400"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8856 8.45715C12.8422 8.53248 12.9217 8.6596 13.0629 8.74121C13.2042 8.82282 13.3542 8.82815 13.3976 8.75282C13.4409 8.67749 13.3615 8.55037 13.2202 8.46876C13.0789 8.38715 12.9289 8.38182 12.8856 8.45715Z",
    fill: "#DB3400"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0787 13.7795L11.7467 13.3947V11.6169L11.0787 12.0017V13.7795Z",
    fill: "#181818"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7083 13.3418V11.8213L11.2632 12.0778V13.5982L11.7083 13.3418Z",
    fill: "#42413D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7467 11.6169L11.7088 11.8212L11.2636 12.0777L11.0787 12.0017L11.7467 11.6169Z",
    fill: "#949491"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2636 13.5981L11.0787 13.7795L11.7467 13.3947L11.7088 13.3417L11.2636 13.5981Z",
    fill: "#424242"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7791 13.8226C11.7791 14.0373 11.6149 14.3116 11.4124 14.4356C11.21 14.5596 11.0461 14.4858 11.0461 14.2714C11.0461 14.0571 11.2103 13.7824 11.4124 13.6584C11.6149 13.5345 11.7791 13.6079 11.7791 13.8226Z",
    fill: "#181818"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.607 14.2563C11.5505 14.3285 11.4842 14.3916 11.4127 14.4355C11.3781 14.4566 11.3455 14.4701 11.3138 14.4798C11.3583 14.4045 11.4202 14.337 11.4886 14.2949C11.5316 14.2686 11.5718 14.2569 11.607 14.2563Z",
    fill: "#040404"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2432 13.808C11.294 13.7487 11.3512 13.696 11.4124 13.6586C11.5333 13.5846 11.6394 13.5824 11.7062 13.6373C11.7068 13.6458 11.7084 13.6539 11.7084 13.6627C11.7084 13.8288 11.597 13.9634 11.4595 13.9634C11.3662 13.9631 11.2856 13.9 11.2432 13.808Z",
    fill: "#949491"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7342 13.9172C11.7342 14.0609 11.6243 14.2449 11.4887 14.3277C11.3531 14.4106 11.2432 14.3613 11.2432 14.2176C11.2432 14.0738 11.3531 13.8899 11.4887 13.807C11.6243 13.7241 11.7342 13.7734 11.7342 13.9172Z",
    fill: "#42413D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 12.9489L11.5922 12.8641V13.1325L11.4453 13.2173L11.4123 13.1981V12.9297L11.4453 12.9489Z",
    fill: "#20211E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5925 13.0589V12.7906L11.4456 12.8753V13.1437L11.5925 13.0589Z",
    fill: "#181818"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5922 12.7907L11.5589 12.7719L11.4123 12.8563L11.4453 12.8755L11.5922 12.7907Z",
    fill: "#949491"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4123 13.1245V12.8561L11.4453 12.8753V13.1437L11.4123 13.1245Z",
    fill: "#040404"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 14.0649L11.5922 13.9805V14.1622L11.4453 14.2467L11.4123 14.2278V14.0461L11.4453 14.0649Z",
    fill: "#20211E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5925 14.089V13.9073L11.4456 13.9917V14.1735L11.5925 14.089Z",
    fill: "#181818"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5922 13.9071L11.5589 13.888L11.4123 13.9724L11.4453 13.9916L11.5922 13.9071Z",
    fill: "#949491"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4123 14.1546V13.9725L11.4453 13.9917V14.1734L11.4123 14.1546Z",
    fill: "#040404"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0.126881 9.44668H0.125626L0.59995 9.72101V9.17392L0.126881 9.44668Z",
    fill: "#1C1C1A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3521 19.2201L11.3158 15.8047L12.3802 15.1901L12.3821 15.1933C12.638 15.0539 12.9892 15.079 13.3769 15.3022C14.1598 15.7529 14.7942 16.8393 14.7942 17.7285C14.7942 18.1551 14.6473 18.457 14.4091 18.6077L14.41 18.6092L14.389 18.6215C14.383 18.6249 14.3774 18.6284 14.3717 18.6315L13.3521 19.2201Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6826 16.0182L13.1266 15.1845C13.2079 15.2146 13.2911 15.2526 13.3765 15.3019C14.1594 15.7526 14.7938 16.839 14.7938 17.7282C14.7938 17.8917 14.7718 18.0364 14.7317 18.162L13.6204 18.8035C13.4989 18.7681 13.3724 18.7157 13.2412 18.64C13.0962 18.5565 12.9565 18.452 12.8237 18.3334L11.7542 16.5395C11.7121 16.3631 11.6867 16.1877 11.6826 16.0182Z",
    fill: "#1F1F1F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9276 16.6906C10.9276 17.5798 11.562 18.6662 12.3449 19.1169C13.1278 19.5676 13.7622 19.2123 13.7622 18.3231C13.7622 17.4339 13.1278 16.3475 12.3449 15.8968C11.5623 15.4461 10.9276 15.8014 10.9276 16.6906Z",
    fill: "#2A2A2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9829 16.7221C10.9829 17.5771 11.5928 18.6214 12.3456 19.0549C13.098 19.4883 13.7083 19.1465 13.7083 18.2918C13.7083 17.4368 13.0983 16.3925 12.3456 15.9591C11.5928 15.5259 10.9829 15.8674 10.9829 16.7221Z",
    fill: "#1D1D1D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2871 16.8979C11.2871 17.5618 11.7608 18.3725 12.345 18.709C12.9292 19.0455 13.4029 18.7803 13.4029 18.1164C13.4029 17.4526 12.9292 16.6418 12.345 16.3053C11.7608 15.9689 11.2871 16.2341 11.2871 16.8979Z",
    fill: "#3B3B3B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.359 16.939C11.359 17.5577 11.8004 18.3135 12.3454 18.6274C12.89 18.9409 13.3317 18.6939 13.3317 18.0749C13.3317 17.4563 12.8903 16.7005 12.3454 16.3866C11.8004 16.073 11.359 16.3204 11.359 16.939Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3577 16.3948C12.8963 16.7127 13.3311 17.461 13.3311 18.075C13.3311 18.1629 13.3214 18.2426 13.3044 18.3151L12.5846 18.7307C12.5077 18.7081 12.428 18.6751 12.3451 18.6274C11.8096 18.3189 11.3748 17.5834 11.3604 16.9707L12.3577 16.3948Z",
    fill: "#A9A9A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8973 16.8963C13.0904 17.1559 13.2338 17.4632 13.2963 17.7617L12.1019 18.4513C11.8696 18.2504 11.6702 17.9757 11.5368 17.6816L12.8973 16.8963Z",
    fill: "#E9EAE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8973 16.8963C13.0904 17.1559 13.2338 17.4632 13.2963 17.7617L12.1019 18.4513C11.8696 18.2504 11.6702 17.9757 11.5368 17.6816L12.8973 16.8963Z",
    fill: "#E9EAE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6746 16.9288C11.6746 17.4206 12.0256 18.0217 12.4588 18.2709C12.892 18.5202 13.243 18.3237 13.243 17.8318C13.243 17.34 12.892 16.7389 12.4588 16.4897C12.0256 16.2405 11.6746 16.4369 11.6746 16.9288Z",
    fill: "#4D4D4D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 16.9615C11.8125 17.3834 12.1135 17.8991 12.4852 18.1128C12.8565 18.3269 13.1579 18.158 13.1579 17.7362C13.1579 17.3143 12.8568 16.7986 12.4852 16.5848C12.1138 16.3708 11.8125 16.5393 11.8125 16.9615Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8354 16.8947C12.8445 16.8812 12.8574 16.8708 12.8722 16.8621C12.912 16.9129 12.9491 16.9663 12.9836 17.0218C12.9519 17.0325 12.9158 17.0338 12.8838 17.0215C12.8247 16.9989 12.8031 16.9421 12.8354 16.8947Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8215 17.2936C11.7766 17.2349 11.786 17.1837 11.8422 17.179C11.8987 17.1743 11.9806 17.2182 12.0255 17.2769C12.0704 17.3356 12.061 17.3868 12.0048 17.3915C11.9486 17.3962 11.8664 17.3523 11.8215 17.2936Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0024 17.7497C12.9873 17.6791 13.0221 17.6521 13.0799 17.6891C13.1377 17.7262 13.1967 17.8134 13.2117 17.8837C13.2268 17.9543 13.192 17.9813 13.1342 17.9443C13.0764 17.9073 13.0174 17.82 13.0024 17.7497Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.137 16.5081C12.1574 16.451 12.2048 16.4579 12.2434 16.5235C12.282 16.5888 12.2967 16.6883 12.2763 16.7451C12.2562 16.8022 12.2085 16.7953 12.1699 16.7297C12.1316 16.6644 12.1169 16.5653 12.137 16.5081Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0091 17.2654C12.9563 17.2174 12.9545 17.1616 13.0047 17.1402C13.0172 17.1349 13.032 17.1324 13.0477 17.132C13.0803 17.1933 13.1095 17.256 13.135 17.3197C13.0916 17.3157 13.0439 17.2972 13.0091 17.2654Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0392 18.1181C13.0294 18.1818 12.9842 18.1856 12.9378 18.1266C12.8916 18.0676 12.8618 17.9684 12.8715 17.9047C12.8813 17.8409 12.9265 17.8372 12.9729 17.8962C13.0191 17.9552 13.0489 18.0544 13.0392 18.1181Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0508 17.5233C13.0137 17.4583 13.0316 17.4128 13.0909 17.4216C13.1205 17.426 13.1547 17.443 13.1861 17.4668C13.2049 17.5302 13.219 17.5936 13.2288 17.6564C13.2275 17.6561 13.2266 17.657 13.2253 17.6567C13.166 17.6479 13.0881 17.5883 13.0508 17.5233Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9496 17.6557C11.8931 17.6181 11.8821 17.5606 11.9254 17.527C11.9688 17.4935 12.0494 17.4969 12.1063 17.5343C12.1628 17.5719 12.1738 17.6294 12.1304 17.663C12.0871 17.6965 12.0061 17.6934 11.9496 17.6557Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3797 18.0712C12.3775 18.0015 12.4158 17.9293 12.4658 17.9096C12.5157 17.8898 12.558 17.9303 12.5602 17.9999C12.5624 18.0696 12.5241 18.1418 12.4742 18.1616C12.4243 18.1811 12.3819 18.1406 12.3797 18.0712Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7888 18.0061C12.8155 18.0765 12.8108 18.1706 12.7778 18.2164C12.7452 18.2623 12.6971 18.2422 12.6705 18.1716C12.6438 18.1012 12.6488 18.0071 12.6815 17.9613C12.7141 17.9154 12.7621 17.9355 12.7888 18.0061Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1156 17.8431C12.1379 17.7866 12.2035 17.7486 12.2619 17.7587C12.3203 17.7684 12.3495 17.8221 12.3272 17.8786C12.3049 17.9351 12.2393 17.9731 12.1809 17.963C12.1222 17.9533 12.093 17.8996 12.1156 17.8431Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0257 16.8977C11.9718 16.85 11.9247 16.7552 11.9206 16.6861C11.9162 16.6171 11.9567 16.5998 12.0107 16.6475C12.0647 16.6952 12.1118 16.79 12.1158 16.8591C12.1202 16.9281 12.0797 16.9454 12.0257 16.8977Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7894 16.7639C12.7674 16.801 12.7335 16.8295 12.6968 16.8343C12.6419 16.8412 12.6045 16.7938 12.6133 16.7285C12.618 16.693 12.6359 16.6604 12.6598 16.6362C12.7046 16.6754 12.748 16.7181 12.7894 16.7639Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8701 16.8944C11.9301 16.9161 12.001 16.9895 12.0293 17.0583C12.0572 17.127 12.0315 17.1653 11.9715 17.1436C11.9115 17.122 11.8406 17.0485 11.8123 16.9798C11.7844 16.9111 11.8101 16.8728 11.8701 16.8944Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 16.5292C12.5233 16.5342 12.5259 16.5376 12.5271 16.5433C12.5434 16.6149 12.5233 16.7012 12.4819 16.7363C12.4408 16.7712 12.3943 16.7417 12.378 16.6701C12.3617 16.5985 12.3818 16.5122 12.4232 16.4771C12.4254 16.4755 12.4273 16.4755 12.4295 16.4742C12.4395 16.4796 12.4493 16.484 12.459 16.4896C12.4803 16.5016 12.5011 16.5154 12.5218 16.5292Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1227 17.1118C12.1227 17.373 12.3092 17.6919 12.539 17.8243C12.7687 17.9568 12.9552 17.8523 12.9552 17.5911C12.9552 17.33 12.7687 17.0111 12.539 16.8786C12.3092 16.7465 12.1227 16.851 12.1227 17.1118Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4227 16.8327C12.4597 16.8418 12.4983 16.8553 12.5388 16.8785C12.7686 17.011 12.9551 17.3299 12.9551 17.591C12.9551 17.6613 12.9406 17.7194 12.9165 17.7652L12.5372 17.6865C12.3897 17.5587 12.3699 17.4124 12.2852 17.2257L12.4227 16.8327Z",
    fill: "#A9A9A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4122 17.525C12.3843 17.4732 12.362 17.4186 12.3391 17.3587C12.4986 17.2975 12.647 17.2115 12.7773 17.1032C12.8483 17.2005 12.9007 17.3125 12.9293 17.4237C12.7484 17.4262 12.5745 17.4623 12.4122 17.525Z",
    fill: "#DCDED9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1227 17.3018C12.1227 17.4873 12.2552 17.7139 12.4184 17.8081C12.5817 17.9023 12.7141 17.8279 12.7141 17.6424C12.7141 17.4569 12.5817 17.2299 12.4184 17.1361C12.2549 17.0419 12.1227 17.116 12.1227 17.3018Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2119 17.4146C12.2119 17.515 12.2838 17.6381 12.3723 17.6889C12.4609 17.7398 12.5324 17.6996 12.5324 17.5992C12.5324 17.4987 12.4605 17.3757 12.3723 17.3248C12.2838 17.2737 12.2119 17.3138 12.2119 17.4146Z",
    fill: "#4D4D4D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.352 19.219L13.9754 18.859C13.9814 18.8558 13.987 18.8524 13.993 18.8489L14.014 18.8367L14.0131 18.8351C14.2514 18.6841 14.3983 18.3822 14.3983 17.9559C14.3983 17.0667 13.7635 15.9804 12.9809 15.5297C12.5933 15.3062 12.242 15.2814 11.9861 15.4207L11.9849 15.4185L12.0549 15.378L12.0565 15.3809C12.3123 15.2415 12.6636 15.2666 13.0513 15.4898C13.8342 15.9405 14.4686 17.0269 14.4686 17.9161C14.4686 18.3426 14.3217 18.6446 14.0834 18.7953L14.0844 18.7968L14.0633 18.8091C14.0574 18.8125 14.0517 18.816 14.0457 18.8191L13.3523 19.2193L13.352 19.219Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 15,
    width: 5,
    height: 5
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 19.5456L11.2962 18.6256L10.7039 16.1491L11.666 15.3151V15.155C11.9115 15.1073 12.2075 15.1676 12.5262 15.3509C13.3477 15.8239 14.0163 16.9425 14.0574 17.8876L14.8589 18.35L12.9713 19.5456Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3514 19.2189L13.6572 19.0422C13.6631 19.0391 13.6688 19.0356 13.6748 19.0322L13.6958 19.0199L13.6948 19.0184C13.9331 18.8677 14.08 18.5654 14.08 18.1392C14.08 17.25 13.4453 16.1636 12.6627 15.7129C12.275 15.4894 11.9237 15.4646 11.6679 15.604L11.6666 15.6018L11.7366 15.5613L11.7382 15.5641C11.9941 15.4248 12.3453 15.4499 12.733 15.673C13.5159 16.1238 14.1503 17.2101 14.1503 18.0993C14.1503 18.5259 14.0034 18.8279 13.7652 18.9785L13.7661 18.9801L13.7451 18.9923C13.7391 18.9958 13.7335 18.9992 13.7278 19.0024L13.352 19.2193L13.3514 19.2189Z",
    fill: "black"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M11.383 15.1197C11.6508 15.0708 11.9719 15.1364 12.3175 15.336C13.2175 15.8533 13.9502 17.0802 13.996 18.1148V18.4983L16.0738 17.2296V16.8505C16.497 16.3621 13.9885 15.653 13.0336 15.3448C12.65 15.2208 11.8658 14.9436 11.5971 14.9961L11.383 15.1197Z",
    fill: "#FFE057"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3175 15.3358C13.2175 15.8531 13.9502 17.08 13.996 18.1146V18.4981L13.8821 18.4325L13.8811 18.0483C13.8783 17.9987 13.873 17.952 13.8658 17.9077C13.7405 16.9501 13.0675 15.8954 12.262 15.4325C12.0159 15.2903 11.7729 15.2156 11.5582 15.2156C11.5365 15.2156 11.5155 15.2162 11.4945 15.2178C11.4565 15.2178 11.4191 15.2218 11.383 15.2291V15.1195C11.6505 15.0702 11.9716 15.1362 12.3175 15.3358Z",
    fill: "#8C4D00"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2353 13.1966V14.3718L14.9416 18.0043V16.8326L15.7682 16.3552V15.1282L20.3739 12.4694V13.696L21.2353 13.1966Z",
    fill: "#BDC3D6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2353 13.1964V14.3719L14.9438 18.0035H14.9416V16.8299L21.2353 13.1964Z",
    fill: "#F7900B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9435 18.0033L14.9416 18.0041V18.0033H14.9435Z",
    fill: "#135E00"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7367 15.1371L20.255 14.838V14.9823L19.7367 15.2815V15.1371Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4396 17.0399L15.9217 17.339V17.4834L16.4396 17.1843V17.0399Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4399 16.835L19.7856 14.9036V13.2037L16.4399 15.135V16.835Z",
    fill: "#1C1C1A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M17.671 15.3929L18.5556 14.8822V14.5853L17.671 15.096V15.3929Z",
    fill: "#C7C6C4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1505 15.1194L12.1502 15.0042L11.5604 14.4471V11.3211L11.7355 11.1909L11.7086 11.1068L11.4769 11.2791V14.4832L12.1505 15.1194Z",
    fill: "#242424"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9418 18.004L13.996 18.4981L13.8381 17.4001L13.2561 16.2673L12.3944 15.3819L14.9418 16.8295V18.004Z",
    fill: "#FFB700"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M20.374 13.6936L21.2354 13.1964L20.374 12.6992V13.6936Z",
    fill: "#FFE057"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0335 14.5028V15.3447L15.7683 16.355V15.1281L13.0335 14.5028Z",
    fill: "#BDC3D6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53178 13.9263L0.599678 8.76611V9.72062L9.53178 14.8811V13.9263Z",
    fill: "#FFB700"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2224 16.4723V16.8533C16.2224 16.9252 16.1832 16.9921 16.1207 17.0278L15.4383 17.4214C15.3833 17.4531 15.3146 17.413 15.3146 17.3496V17.3041L15.8859 16.9751C15.9484 16.939 15.9876 16.8725 15.9876 16.8006V16.4651L16.0987 16.4016C16.1537 16.3696 16.2224 16.4098 16.2224 16.4723Z",
    fill: "#8C4D00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0113 13.706V14.0857C21.0113 14.1589 20.9733 14.2254 20.9108 14.2615L20.2271 14.6542C20.1722 14.6859 20.1044 14.6457 20.1044 14.5833V14.5368L20.6747 14.2088C20.7372 14.1727 20.7764 14.1061 20.7764 14.0333V13.6991L20.8876 13.6344C20.9425 13.6036 21.0113 13.6425 21.0113 13.706Z",
    fill: "#8C4D00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9876 16.4644V16.8C15.9876 16.8719 15.9484 16.9387 15.8859 16.9745L15.3146 17.3034V16.9692C15.3146 16.896 15.3538 16.8295 15.4163 16.7934L15.9876 16.4644Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7764 13.6987V14.033C20.7764 14.1058 20.7372 14.1727 20.6747 14.2084L20.1044 14.5364V14.2022C20.1044 14.1303 20.1423 14.0634 20.2048 14.0276L20.7764 13.6987Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5016 15.5905C12.5016 15.5905 11.9774 15.3413 11.6245 15.4734C11.2717 15.6056 11.046 16.1141 11.046 16.1141L10.9643 16.347L10.6033 16.1433C10.6033 16.1433 10.8168 15.6291 10.9342 15.4621C11.046 15.3033 11.2456 15.1326 11.3828 15.1194C11.5627 15.1021 12.0919 15.2572 12.0919 15.2572C12.0919 15.2572 12.4925 15.5136 12.5016 15.5905Z",
    fill: "#FFB700"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09132 12.4322C3.0728 12.4202 3.10513 12.4068 3.2398 12.4256C3.25361 12.4196 3.26743 12.4124 3.28061 12.4024C3.3481 12.3503 3.43286 12.3116 3.50506 12.2649C3.64695 12.1732 3.77502 12.07 3.90593 11.9636C4.09396 11.8107 4.30334 11.6585 4.48416 11.4846C4.16616 10.8709 3.68148 10.3367 3.1563 10.0153C1.24551 8.8461 1.13564 10.6741 1.13564 10.6741L1.42789 10.843C1.42789 10.843 1.69283 12.3474 2.10877 12.9466C2.33353 12.6315 2.7005 12.4479 3.09132 12.4322Z",
    fill: "#1D1D1D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84845 13.7478L1.81209 10.3324L2.87657 9.71785L2.87845 9.72099C3.13429 9.58163 3.48556 9.60674 3.87325 9.82991C4.65615 10.2806 5.29057 11.367 5.29057 12.2562C5.29057 12.6828 5.14366 12.9847 4.9054 13.1354L4.90634 13.1369L4.88531 13.1492C4.87966 13.1526 4.87369 13.1561 4.86773 13.1592L3.84845 13.7478Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17961 10.5462L3.62362 9.71255C3.70492 9.743 3.78811 9.78066 3.87349 9.82994C4.65639 10.2807 5.29081 11.367 5.29081 12.2562C5.29081 12.4198 5.26884 12.5645 5.22866 12.69L4.1174 13.3316C3.99592 13.2961 3.86941 13.2437 3.73819 13.1681C3.59317 13.0846 3.45347 12.98 3.32069 12.8614L2.25118 11.0676C2.20912 10.8912 2.18369 10.7157 2.17961 10.5462Z",
    fill: "#1F1F1F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42393 11.2188C1.42393 12.108 2.05866 13.1943 2.84125 13.6451C3.62415 14.0958 4.25857 13.7405 4.25857 12.8512C4.25857 11.962 3.62415 10.8757 2.84125 10.425C2.05866 9.97391 1.42393 10.3295 1.42393 11.2188Z",
    fill: "#2A2A2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47919 11.2502C1.47919 12.1049 2.08944 13.1495 2.84189 13.5829C3.59434 14.0164 4.20459 13.6746 4.20459 12.8199C4.20459 11.9652 3.59465 10.9206 2.84189 10.4874C2.08912 10.0537 1.47919 10.3955 1.47919 11.2502Z",
    fill: "#1D1D1D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.78346 11.4255C1.78346 12.0893 2.25716 12.9001 2.84135 13.2366C3.42555 13.573 3.89924 13.3078 3.89924 12.6439C3.89924 11.9801 3.42555 11.1693 2.84135 10.8329C2.25716 10.4964 1.78346 10.7616 1.78346 11.4255Z",
    fill: "#3B3B3B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85536 11.467C1.85536 12.0857 2.29704 12.8415 2.84168 13.1554C3.38632 13.469 3.828 13.2219 3.828 12.603C3.828 11.9843 3.38632 11.2285 2.84168 10.9146C2.29672 10.601 1.85536 10.8484 1.85536 11.467Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.854 10.9228C3.39268 11.2408 3.82745 11.9891 3.82745 12.603C3.82745 12.6909 3.81772 12.7706 3.80077 12.8431L3.08096 13.2587C3.00405 13.2364 2.92432 13.2032 2.84144 13.1555C2.30591 12.8469 1.87114 12.1115 1.8567 11.4988L2.854 10.9228Z",
    fill: "#A9A9A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.39364 11.4242C3.5867 11.6837 3.73015 11.991 3.79262 12.2895L2.59818 12.9791C2.36588 12.7782 2.16655 12.5036 2.03313 12.2098L3.39364 11.4242Z",
    fill: "#E9EAE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.39364 11.4242C3.5867 11.6837 3.73015 11.991 3.79262 12.2895L2.59818 12.9791C2.36588 12.7782 2.16655 12.5036 2.03313 12.2098L3.39364 11.4242Z",
    fill: "#E9EAE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17096 11.4566C2.17096 11.9485 2.52191 12.5496 2.95512 12.7988C3.388 13.0483 3.73927 12.8515 3.73927 12.3597C3.73927 11.8678 3.38832 11.2667 2.95512 11.0175C2.52223 10.768 2.17096 10.9648 2.17096 11.4566Z",
    fill: "#4D4D4D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.30878 11.4892C2.30878 11.911 2.60982 12.4267 2.98149 12.6405C3.35286 12.8545 3.65421 12.6857 3.65421 12.2638C3.65421 11.842 3.35317 11.3263 2.98149 11.1125C2.61013 10.8988 2.30878 11.0673 2.30878 11.4892Z",
    fill: "#949494"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.332 11.4229C3.34111 11.4094 3.35398 11.399 3.36873 11.3903C3.40829 11.4411 3.44564 11.4945 3.48017 11.55C3.44815 11.5607 3.41237 11.562 3.38035 11.5497C3.32133 11.5268 3.29967 11.4703 3.332 11.4229Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31805 11.8216C2.27316 11.7629 2.28258 11.7117 2.33877 11.707C2.39527 11.7023 2.47721 11.7462 2.52209 11.8049C2.56698 11.8636 2.55757 11.9148 2.50138 11.9195C2.44519 11.9242 2.36294 11.8806 2.31805 11.8216Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49894 12.2777C3.48387 12.2071 3.51872 12.1801 3.57648 12.2171C3.63424 12.2542 3.69325 12.3414 3.70832 12.4117C3.72339 12.4824 3.68854 12.5093 3.63078 12.4723C3.57302 12.4353 3.51401 12.3483 3.49894 12.2777Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63354 11.0363C2.65364 10.9792 2.70135 10.9861 2.73996 11.0517C2.77857 11.117 2.79333 11.2165 2.77292 11.2733C2.75252 11.3304 2.70512 11.3235 2.66651 11.2579C2.62821 11.1926 2.61345 11.0931 2.63354 11.0363Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50565 11.7935C3.45291 11.7454 3.45103 11.6896 3.50126 11.6682C3.51381 11.6629 3.52857 11.6604 3.54426 11.6601C3.57691 11.7213 3.60642 11.784 3.63153 11.8478C3.58821 11.844 3.54049 11.8255 3.50565 11.7935Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53574 12.6464C3.526 12.7102 3.4808 12.7139 3.43434 12.6549C3.3882 12.5959 3.35837 12.4967 3.36811 12.433C3.37784 12.3693 3.42304 12.3655 3.4695 12.4245C3.51564 12.4832 3.54515 12.5827 3.53574 12.6464Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54735 12.0516C3.51031 11.9867 3.5282 11.9411 3.58722 11.9499C3.61673 11.9543 3.65094 11.9713 3.68234 11.9951C3.70117 12.0585 3.7153 12.1219 3.72503 12.1847C3.72377 12.1844 3.72283 12.1853 3.72157 12.185C3.66256 12.1762 3.58439 12.1166 3.54735 12.0516Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44627 12.1841C2.38976 12.1464 2.37878 12.089 2.42178 12.0554C2.4651 12.0218 2.54578 12.0253 2.6026 12.0626C2.6591 12.1003 2.67009 12.1577 2.62677 12.1913C2.58376 12.2249 2.50277 12.2214 2.44627 12.1841Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87633 12.5992C2.87413 12.5295 2.91243 12.4573 2.96234 12.4376C3.01225 12.4178 3.05463 12.4583 3.05683 12.528C3.05902 12.5976 3.02073 12.6698 2.97081 12.6896C2.9209 12.7094 2.87852 12.6689 2.87633 12.5992Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28538 12.5341C3.31207 12.6044 3.30704 12.6986 3.2744 12.7444C3.24175 12.7899 3.19372 12.7701 3.16704 12.6995C3.14036 12.6292 3.14538 12.535 3.17803 12.4892C3.21067 12.4434 3.2587 12.4638 3.28538 12.5341Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61207 12.3711C2.63436 12.3146 2.69997 12.2767 2.75836 12.2867C2.81674 12.2964 2.84594 12.3501 2.82365 12.4066C2.80136 12.4631 2.73575 12.5011 2.67737 12.491C2.61898 12.4813 2.58978 12.4276 2.61207 12.3711Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52228 11.4259C2.46829 11.3781 2.4212 11.2834 2.41712 11.2146C2.41304 11.1456 2.45322 11.1283 2.50721 11.176C2.5612 11.2237 2.60829 11.3185 2.61237 11.3876C2.61645 11.4563 2.57627 11.4736 2.52228 11.4259Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28599 11.2918C3.26402 11.3288 3.23012 11.3574 3.19339 11.3621C3.13845 11.369 3.1011 11.3216 3.10989 11.2563C3.11459 11.2208 3.13249 11.1882 3.15635 11.164C3.20124 11.2033 3.24456 11.246 3.28599 11.2918Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36669 11.4228C2.42665 11.4444 2.4979 11.5179 2.52584 11.5866C2.55378 11.6554 2.52804 11.6937 2.46808 11.672C2.40813 11.6503 2.33718 11.5769 2.30893 11.5081C2.28099 11.4394 2.30673 11.4011 2.36669 11.4228Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01836 11.0575C3.01993 11.0625 3.02244 11.066 3.0237 11.0716C3.04002 11.1432 3.01993 11.2298 2.97849 11.2647C2.93737 11.2998 2.89091 11.27 2.87459 11.1985C2.85826 11.1269 2.87835 11.0403 2.91948 11.0054C2.92136 11.0039 2.92356 11.0038 2.92576 11.0026C2.9358 11.0079 2.94553 11.0123 2.95558 11.018C2.97692 11.0299 2.99764 11.0437 3.01836 11.0575Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61904 11.6399C2.61904 11.9011 2.80551 12.22 3.03529 12.3524C3.26508 12.4849 3.45154 12.3804 3.45154 12.1192C3.45154 11.8581 3.26508 11.5392 3.03529 11.4067C2.80551 11.2746 2.61904 11.3788 2.61904 11.6399Z",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91899 11.3607C2.95603 11.3699 2.99464 11.3834 3.03514 11.4066C3.26492 11.539 3.45139 11.8579 3.45139 12.1191C3.45139 12.1894 3.43695 12.2475 3.41277 12.2933L3.03357 12.2145C2.88603 12.0868 2.86625 11.9405 2.78149 11.7537L2.91899 11.3607Z",
    fill: "#A9A9A9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90857 12.0527C2.88063 12.001 2.85834 11.9463 2.83543 11.8864C2.99489 11.8252 3.14338 11.7392 3.27365 11.6309C3.34428 11.7282 3.39702 11.8403 3.42558 11.9514C3.24477 11.9539 3.07086 11.99 2.90857 12.0527Z",
    fill: "#DCDED9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.61904 11.8296C2.61904 12.0151 2.75151 12.2417 2.91475 12.3359C3.07798 12.4301 3.21046 12.356 3.21046 12.1702C3.21046 11.9847 3.07798 11.7581 2.91475 11.6639C2.75151 11.57 2.61904 11.6441 2.61904 11.8296Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70826 11.9424C2.70826 12.0429 2.78015 12.1659 2.86836 12.2168C2.95688 12.2676 3.02877 12.2274 3.02877 12.127C3.02877 12.0265 2.95688 11.9035 2.86836 11.8527C2.77983 11.8018 2.70826 11.842 2.70826 11.9424Z",
    fill: "#4D4D4D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84831 13.7467L4.47174 13.3867C4.47771 13.3836 4.48336 13.3801 4.48932 13.3766L4.51036 13.3644L4.50941 13.3628C4.74767 13.2119 4.89459 12.9099 4.89459 12.4837C4.89459 11.5944 4.26017 10.5081 3.47727 10.0574C3.08958 9.83388 2.73831 9.80908 2.48247 9.94844L2.48122 9.94625L2.55122 9.90576L2.55279 9.90858C2.80863 9.76922 3.1599 9.79433 3.54758 10.0175C4.33048 10.4682 4.9649 11.5546 4.9649 12.4438C4.9649 12.8704 4.81799 13.1723 4.57973 13.323L4.58067 13.3245L4.55964 13.3368C4.55368 13.3402 4.54803 13.3437 4.54206 13.3468L3.84863 13.747L3.84831 13.7467Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_794_29231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 5,
    height: 6
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4676 14.0732L1.79224 13.1532L1.26015 10.7461C1.26015 10.7461 1.37662 10.3148 1.59385 10.118C1.82049 9.91275 2.11934 9.86096 2.42132 9.90898C2.65644 9.94633 2.82094 10.0546 3.01211 10.1645C3.83362 10.6375 4.5123 11.4702 4.55343 12.4156L5.35485 12.878L3.4676 14.0732Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_794_29231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84774 13.7467L4.15349 13.5699C4.15946 13.5668 4.16511 13.5634 4.17107 13.5599L4.1921 13.5477L4.19116 13.5461C4.42942 13.3951 4.57633 13.0932 4.57633 12.6669C4.57633 11.7777 3.9416 10.6914 3.15901 10.2406C2.77133 10.0171 2.42006 9.99234 2.16422 10.1317L2.16296 10.1295L2.23297 10.089L2.23454 10.0918C2.49038 9.95248 2.84165 9.97759 3.22933 10.2008C4.01223 10.6515 4.64665 11.7378 4.64665 12.6271C4.64665 13.0536 4.49974 13.3556 4.26148 13.5062L4.26242 13.5078L4.24139 13.52C4.23542 13.5235 4.22977 13.5269 4.22381 13.5301L3.84805 13.747L3.84774 13.7467Z",
    fill: "black"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6015 14.248V15.1739L15.0878 18.9327H14.7482L14.6687 18.8862C14.4116 18.7371 14.3385 18.3021 14.3385 18.0048L14.4729 17.9232C14.5171 17.8969 14.5724 17.8969 14.6166 17.9223L14.7478 17.9986L14.9415 18.0039H14.9437L15.0875 18.007L21.3134 14.4147V14.2772L21.2352 14.2317V14.0697L21.2638 14.0528L21.6015 14.248Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4665 18.0117L14.749 18.1759V19.1103L14.6689 19.0639C14.4122 18.9145 14.254 18.6395 14.254 18.3423V18.1338C14.254 18.0249 14.372 17.9568 14.4665 18.0117Z",
    fill: "#1E1E1E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0875 19.1103L21.6019 15.3512V14.4256L15.0875 18.1843V19.1103Z",
    fill: "#4A4A45"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7486 18.1762L15.0877 18.1844V19.1103H14.7486V18.1762Z",
    fill: "#363631"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 15.1279V15.3366L13.0337 14.5026L12.7665 13.6834L15.7685 15.1279Z",
    fill: "#D8DDE8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20903 9.67355L8.81946 9.44599C8.71273 9.38447 8.57932 9.46074 8.57932 9.58472V9.69897V10.5339V11.1824C8.57932 11.322 8.65434 11.4523 8.7752 11.522L9.16477 11.7496C9.2715 11.8108 9.40491 11.7335 9.40491 11.6108V11.1463V10.3114V10.0132C9.40491 9.87255 9.32957 9.74323 9.20903 9.67355Z",
    fill: "url(#paint3_linear_794_29231)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83442 6.48197C2.99545 6.57331 3.10344 6.7494 3.00581 6.9575L2.86455 7.25789C2.76787 7.46348 2.57481 7.46756 2.4144 7.37527L2.11398 7.20515L2.534 6.31216L2.83442 6.48197ZM2.52081 7.16686C2.58988 7.20578 2.6401 7.18475 2.66741 7.12699L2.79863 6.84827C2.82594 6.7902 2.81024 6.73528 2.74212 6.69667L2.63885 6.63829L2.41785 7.10848L2.52081 7.16686Z",
    fill: "#FFB700"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29489 7.18653L3.62011 7.37078L3.52813 7.56632L3.20292 7.38207L3.13982 7.51579L3.4936 7.71604L3.39315 7.92917L2.83438 7.61247L3.25471 6.71979L3.81348 7.03618L3.71365 7.24805L3.36019 7.04779L3.29489 7.18653Z",
    fill: "#FFB700"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9202 7.09714L4.12424 7.21265L3.80907 7.88215L4.13554 8.06703L4.0307 8.2902L3.50018 7.98982L3.9202 7.09714Z",
    fill: "#FFB700"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31218 8.44991L4.10939 8.33503L4.52941 7.44235L4.7322 7.55723L4.31218 8.44991Z",
    fill: "#FFB700"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33278 7.89517L5.55032 8.01852L4.84119 8.74767L4.65535 8.64252L4.78625 7.586L5.00379 7.70935L4.92437 8.2169L4.86096 8.44948L4.86442 8.45136L4.99971 8.26147L5.33278 7.89517Z",
    fill: "#FFB700"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6292 8.50867L5.95441 8.69292L5.86244 8.88846L5.53722 8.70422L5.47412 8.83793L5.8279 9.03819L5.72745 9.25131L5.16869 8.93492L5.58902 8.04193L6.14778 8.35832L6.04796 8.57019L5.69449 8.36994L5.6292 8.50867Z",
    fill: "#FFB700"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22326 9.17321L6.18684 9.1528L6.05343 9.43655L5.84813 9.32041L6.26815 8.42743L6.58897 8.60916C6.7544 8.7027 6.84292 8.85995 6.74875 9.07182C6.6709 9.23692 6.56699 9.29625 6.45367 9.2749L6.52838 9.70524L6.27537 9.5621L6.22326 9.17321ZM6.39717 9.02568C6.52524 9.09819 6.6213 8.89417 6.49322 8.82135L6.37425 8.75386L6.27819 8.9582L6.39717 9.02568Z",
    fill: "#FFB700"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7395 9.82445L6.90493 9.47259L6.87951 8.77295L7.11526 8.90635L7.10615 9.31659L7.40563 9.07082L7.64389 9.20548L7.10804 9.58716L6.9426 9.93901L6.7395 9.82445Z",
    fill: "#FFB700"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2334 13.339C15.3583 13.2659 15.5099 13.2558 15.5897 13.3905L15.7045 13.5848C15.783 13.7179 15.7005 13.8447 15.5749 13.9172L15.3417 14.054L15.0001 13.4762L15.2334 13.339ZM15.4989 13.7769C15.5526 13.7455 15.5623 13.7056 15.5401 13.668L15.4336 13.4875C15.4113 13.4498 15.3718 13.441 15.3191 13.4721L15.239 13.5192L15.4189 13.8236L15.4989 13.7769Z",
    fill: "#FFB700"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8536 13.2808L16.106 13.1327L16.1807 13.2592L15.928 13.4073L15.9791 13.4939L16.2538 13.3329L16.3354 13.4707L15.9016 13.7253L15.5601 13.1471L15.9939 12.8925L16.0749 13.0297L15.8002 13.1907L15.8536 13.2808Z",
    fill: "#FFB700"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0774 12.8438L16.2359 12.7509L16.4921 13.1844L16.7454 13.0356L16.8308 13.18L16.4189 13.4217L16.0774 12.8438Z",
    fill: "#FFB700"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0499 13.0513L16.8923 13.1439L16.5508 12.5657L16.7084 12.4734L17.0499 13.0513Z",
    fill: "#FFB700"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1736 12.1993L17.3425 12.1001L17.4596 12.8098L17.3152 12.8945L16.7492 12.4482L16.9181 12.349L17.1827 12.5741L17.2919 12.6949L17.2944 12.6933L17.242 12.5405L17.1736 12.1993Z",
    fill: "#FFB700"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 12.2165L17.9199 12.0684L17.9946 12.1949L17.7419 12.343L17.7931 12.4297L18.0675 12.2687L18.1491 12.4064L17.7152 12.661L17.3737 12.0828L17.8075 11.8283L17.8885 11.9654L17.6138 12.1265L17.6672 12.2165Z",
    fill: "#FFB700"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3224 12.0578L18.2942 12.0744L18.4028 12.258L18.2433 12.3512L17.9018 11.7734L18.1507 11.6271C18.2791 11.5518 18.4109 11.5483 18.4944 11.6817C18.5575 11.7884 18.5466 11.8763 18.4841 11.9429L18.7713 12.0414L18.5751 12.1566L18.3224 12.0578ZM18.3124 11.8942C18.4116 11.8358 18.3334 11.7037 18.2342 11.7621L18.1416 11.8164L18.2198 11.9485L18.3124 11.8942Z",
    fill: "#FFB700"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9368 11.9448L18.8021 11.717L18.3777 11.4941L18.5607 11.3868L18.7986 11.533L18.7858 11.2546L18.9704 11.1463L18.9591 11.6247L19.0937 11.8526L18.9368 11.9448Z",
    fill: "#FFB700"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_794_29231",
    x1: 17.3295,
    y1: 9.93252,
    x2: 17.6331,
    y2: 7.69969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9409,
    stopColor: "#6F797B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_794_29231",
    x1: 16.009,
    y1: 11.8602,
    x2: 15.0981,
    y2: 9.56926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0837,
    stopColor: "#597E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4241,
    stopColor: "#4D6976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9409,
    stopColor: "#3C4B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_794_29231",
    x1: 10.6353,
    y1: 12.859,
    x2: 11.7606,
    y2: 10.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0837,
    stopColor: "#305F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#29485A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9409,
    stopColor: "#1F2B36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_794_29231",
    x1: 8.44047,
    y1: 11.9895,
    x2: 9.56574,
    y2: 9.14932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0837,
    stopColor: "#305F76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4391,
    stopColor: "#29485A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9409,
    stopColor: "#1F2B36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.d876e6e8f63c234b1e699e17fa5b9e94.svg";
export { ForwardRef as ReactComponent };